import { FaStar } from "react-icons/fa";
import './ReviewCard.css'; // Make sure you have this CSS file

export default function ReviewCard({ rating = 5, heading, text, image, name, role }) {
  return (
    <div className='review-section-card'>
      <div className='review-section-card-line'>
        <div className='review-section-card-star'>
          {Array.from({ length: rating }).map((_, index) => (
            <FaStar color='#F3CD03' key={index} />
          ))}
        </div>
        <div className='review-section-card-text'>
          {/* <h1>{heading}</h1> */}
          <p>{text}</p>
        </div>
        <div className='review-section-card-profile'>
          <div className='review-section-card-profile-img'>
            <img src={image} alt={name} />
          </div>
          <div className='review-section-card-profile-text'>
            <h1>{name}</h1>
            <p>{role}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
